<template>
    <div class="new-tabs1" :style="{'margin': '0px','padding':'0px','height': this.winClientHeight}">
        <!-- pageTab  -->
        <el-tabs v-model="editableTabsValue" type="card" @tab-remove="removeTab" @tab-click="saveCurrentTab">
            <el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name" :vue="item.vue"
                :closable="((cui_type=='5'&&item.title==='业务看板')||(cui_type!=='5'&&item.title==='数据看板')?false:true)">
                <component :is=item.content :pri_detail="{  info:{jsonobj:item} }" @child_event="childEvent"></component>
            </el-tab-pane>
        </el-tabs>

        <!--    <router-view></router-view>-->
    </div>
</template>

<script>
import Bus from '../../utils/Bus'

export default {
    name: 'IndexRight',

    created() {
        let that = this
        this.cui_type = this.customGlobal.userInfoExt.cui_type
        this.initMenu ()
        // this.addTab({
        //     caption: '数据概览',
        //     id: 'M_B_20220527_142106229_107593091',
        //     url: 'DataBoard.vue',
        //     vue: '/views/bankPlatform/mobileBanking/DataBoard.vue',
        // })
        // if (this.customGlobal.userInfoExt.cui_type == '5') {
        //     this.addTab({
        //         caption: '业务看板',
        //         id: 'M_B_20220112_143421931_104185959',
        //         url: 'BusinessKanban.vue',
        //         vue: '/views/bankPlatform/deviceIndex/BusinessKanban.vue',
        //     })
        // } else {
        //     this.addTab({
        //         caption: '数据看板',
        //         id: 'M_B_20220527_142106229_107593091',
        //         url: 'DataBoard.vue',
        //         vue: '/views/bankPlatform/mobileBanking/DataBoard.vue',
        //     })
        // }
    },

    data() {
        return {
            winClientHeight: document.documentElement.clientHeight - 105 + 'px',

            // bodyBgImage: 'url(' + require('@/assets/images/login_bg2.jpg') + ')',
            editableTabsValue: '1',
            editableTabs: [],
            cui_type: '0',
            dom: document.body,
            // editableTabs: [{
            //   title: 'Tab 1',
            //   name: '1',
            //   content: 'Tab 1 content'
            // }, {
            //   title: 'Tab 2',
            //   name: '2',
            //   content: 'Tab 2 content'
            // }],
            tabIndex: 1
        }
    },
    methods: {
        initMenu () {
          for (let item of this.customGlobal.userMenuForPermission) {
            if (item.url === 'Home.vue') {
              this.addTab({
                caption: item.caption,
                id: item.id,
                url: item.url,
                vue: item.vue
              })
              break
            }
          }
        },
        childEvent(args) {
          this.$emit('parent_method2', {
            id: args.id,
            // parentId: args.parentId,
          })
          this.addTab(args)
        },
        // addTab(targetTitle,targetId,url) {
        addTab(obj) {
            console.info('targetTitle:', obj.caption)
            let already = false
            this.editableTabs.forEach((tab, index) => {
                if (tab.name === obj.id) {
                    console.info('该Tab已经存在')
                    already = true
                    this.editableTabsValue = obj.id
                    // window.sessionStorage.setItem('currentTab',JSON.stringify(obj));
                    window.sessionStorage.setItem(
                        'currentTab',
                        this.customGlobal.encrypt(
                            JSON.stringify(obj),
                            this.customGlobal.cryptoKey
                        )
                    )
                    return
                }
            })
            if (already == false) {
                //注意全路径
                // let Acomponent  = () => import('@/components' + obj.vue);
                let Acomponent = () =>
                    import('@/components' + obj.vue).catch((error) => {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            // iconClass:'el-icon-info',
                            message:
                                '<spand style="color:black;">出错了：' +
                                error +
                                '</spand>',
                        })
                    })

                this.editableTabs.push({
                    title: obj.caption,
                    name: obj.id,
                    vue: obj.vue,
                    parentId: obj.parentId,
                    url: obj.url,
                    // content: obj.url,
                    content: Acomponent,
                })
                this.editableTabsValue = obj.id
                // window.sessionStorage.setItem('currentTab',JSON.stringify(obj));
                window.sessionStorage.setItem(
                    'currentTab',
                    this.customGlobal.encrypt(
                        JSON.stringify(obj),
                        this.customGlobal.cryptoKey
                    )
                )
                // this.$router.push({name:obj.url});
            }
        },
        removeTab(targetId) {
            let tabs = this.editableTabs
            let activeName = this.editableTabsValue
            if (activeName === targetId) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetId) {
                        let nextTab = tabs[index + 1] || tabs[index - 1]
                        if (nextTab) {
                            activeName = nextTab.name
                            // window.sessionStorage.setItem('currentTab',JSON.stringify({parentId:nextTab.parentId,id:nextTab.name,caption:nextTab.title,vue:nextTab.vue}));
                            window.sessionStorage.setItem(
                                'currentTab',
                                this.customGlobal.encrypt(
                                    JSON.stringify({
                                        parentId: nextTab.parentId,
                                        id: nextTab.name,
                                        caption: nextTab.title,
                                        vue: nextTab.vue,
                                    }),
                                    this.customGlobal.cryptoKey
                                )
                            )
                        }
                    }
                })
            }

            this.editableTabsValue = activeName
            this.editableTabs = tabs.filter((tab) => tab.name !== targetId)
        },
        saveCurrentTab(tab, event) {
            console.info('tab.name:' + tab.name)
            // this.$emit("parent_method2",tab.name);
            for (let i1 = 0; i1 < this.editableTabs.length; i1++) {

                if (this.editableTabs[i1].name === tab.name) {
                    let obj = {
                        id: tab.name,
                        caption: tab.label,
                        vue: this.editableTabs[i1].vue,
                        parentId: this.editableTabs[i1].parentId,
                    }
                    this.$emit('parent_method2', {
                        id: tab.name,
                        parentId: this.editableTabs[i1].parentId,
                    })
                    // window.sessionStorage.setItem('currentTab',JSON.stringify(obj));
                    window.sessionStorage.setItem(
                        'currentTab',
                        this.customGlobal.encrypt(
                            JSON.stringify(obj),
                            this.customGlobal.cryptoKey
                        )
                    )
                    break
                }
            }
        },
    },
    mounted() {
        let that = this
        window.addEventListener('resize', function () {
            //that.winClientHeight = (document.documentElement.clientHeight);
            that.winClientHeight =
                document.documentElement.clientHeight - 105 + 'px'
            console.info('winClientHeight:' + that.winClientHeight)
        })
        // document.body.style.backgroundImage = this.bodyBgImage;
    },
}
</script>

<style scoped>
/*<style > */
/*tabs下面的距离*/
.new-tabs1 /deep/ .el-tabs > .el-tabs__header {
    margin-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/IndexRight.vue